
























import { Prop, Component, Vue } from 'vue-property-decorator';
import { notificationService } from '@/services/NotificationService';
import { fetchNotifications_notifications } from '@/types/graphql/schemaTypes';
import Notification from '@/components/notification/Notification.vue';
import NavBar from '@/components/layout/NavBar.vue';

@Component({
  components: {
    Notification,
    'nav-bar': NavBar
  }
})
export default class NotificationsView extends Vue {
  public notifications: fetchNotifications_notifications[] = [];
  public created() {
    this.fetchNotifications();
  }

  public fetchNotifications(): void {
    notificationService.fetchNotifications({ language: this.$i18n.locale })
      .then((response: any): void => {
        this.notifications = response.data.notifications;
      }).catch((): void => {
        this.$store.dispatch('Alert/addAlert', { type: 'error', message: this.$t('error.fetch') });
      });
  }
}
